const RolloutWorkplan = 'RolloutWorkplan';
const PauseWorkplan = 'PauseWorkplan';
const StopWorkplan = 'StopWorkplan';
const EditRolloutWorkplan = 'EditRolloutWorkplan';
const EditPauseWorkplan = 'EditPauseWorkplan';
const EditStopWorkplan = 'EditStopWorkplan';
const ManageShiftLine = 'ManageShiftLine';
const PauseShiftLine = 'PauseShiftLine';
const StopShiftLine = 'StopShiftLine';
const EditPauseShiftLine = 'EditPauseShiftLine';
const EditStopShiftLine = 'EditStopShiftLine';
const PauseShiftLineOwner = 'PauseShiftLineOwner';
const StopShiftLineOwner = 'StopShiftLineOwner';
const ManageOwners = 'ManageOwners';
const ManageAssignment = 'ManageAssignment';
const ManageReliefs = 'ManageReliefs';
const AddJobTransfer = 'AddJobTransfer';
const SetSkillAndCertificationProfiles = 'SetSkillAndCertificationProfiles';

export const WorkplanActions = Object.freeze({
    [RolloutWorkplan]: RolloutWorkplan,
    [PauseWorkplan]: PauseWorkplan,
    [StopWorkplan]: StopWorkplan,
    [EditRolloutWorkplan]: EditRolloutWorkplan,
    [EditPauseWorkplan]: EditPauseWorkplan,
    [EditStopWorkplan]: EditStopWorkplan,
    [ManageShiftLine]: ManageShiftLine,
    [PauseShiftLine]: PauseShiftLine,
    [StopShiftLine]: StopShiftLine,
    [EditPauseShiftLine]: EditPauseShiftLine,
    [EditStopShiftLine]: EditStopShiftLine,
    [PauseShiftLineOwner]: PauseShiftLineOwner,
    [StopShiftLineOwner]: StopShiftLineOwner,
    [ManageOwners]: ManageOwners,
    [ManageAssignment]: ManageAssignment,
    [ManageReliefs]: ManageReliefs,
    [AddJobTransfer]: AddJobTransfer,
    [SetSkillAndCertificationProfiles]: SetSkillAndCertificationProfiles,
});
